import { MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import { Outlet } from 'react-router'

import { NavBar } from '../NavBar/NavBar'
import { Footer } from '../Footer/Footer'
import React from 'react'

export function MainLayout() {

    return (
        <>
            <MDBContainer fluid className={'border border-0 border-danger d-flex flex-column w-100 h-100'}>
                <MDBRow className={'border border-0 border-success'}>
                    <NavBar />
                </MDBRow>
                <MDBRow className={'border border-0 border-info flex-grow-1'}>
                    <Outlet />
                </MDBRow>
                <MDBRow className={'border border-0 border-warning'}>
                    <Footer />
                </MDBRow>
            </MDBContainer>
        </>
    )
}